/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';

import BenefitsService from 'src/services/benefits.service';

export const useBenefitsVersion = (
  // eslint-disable-next-line no-unused-vars
  params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
    search: string;
    companyId: string;
  }
) => {
  const result = useQuery({
    queryKey: ['benefits-version-management'],
    queryFn: () => BenefitsService.getBenefitsVersion(params).then(resp => resp.data),
    enabled: true,
  });
  return result;
};
